import { GridColDef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { IAppVersion } from '@Types/AppVersionType';

export const getPlatformLabel = (platform: number) =>
  platform === 1 ? 'Android' : platform === 2 ? 'iOS' : 'Unknown';

export const getPolicyLabel = (type: number) =>
  type === 1 ? 'Optional' : type === 2 ? 'Flexible' : type === 3 ? 'Immediate' : 'None';

export const versionColumns: GridColDef<IAppVersion>[] = [
  {
    field: 'platform',
    headerName: 'App Platform',
    flex: 0.2,
    sortable: true,
    renderCell: ({ value }) => (
      <Tooltip title={value}>
        <span className='table-cell-truncate'>{getPlatformLabel(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: 'versionTag',
    headerName: 'App Version',
    flex: 0.2,
    sortable: true,
    renderCell: ({ value }) => (
      <Tooltip title={value}>
        <span className='table-cell-truncate'>{value}</span>
      </Tooltip>
    ),
  },
  {
    field: 'policyType',
    headerName: 'Type',
    flex: 0.2,
    sortable: true,
    renderCell: ({ value }) => (
      <Tooltip title={value}>
        <span className='table-cell-truncate'>{getPolicyLabel(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: 'createdAt',
    headerName: 'Date',
    flex: 0.2,
    sortable: true,
    renderCell: ({ value }) => (
      <Tooltip title={value}>
        <span className='table-cell-truncate'>
          {new Date(value).toLocaleDateString()}
        </span>
      </Tooltip>
    ),
  },
];
